import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Navigation } from "swiper/modules";
import "swiper/css/navigation";
import { handleGetFoodCategory } from "../../../services/get_without_auth";
import isValidURL from "../../../ValidateUrl";

const BrowsByCategories = () => {
  const [foodCategory, setFoodCategory] = useState([]);

  // GET Food category - API
  useEffect(() => {
    (async () => {
      try {
        const response = await handleGetFoodCategory();
        setFoodCategory(response);
      } catch (error) {
        console.error("Error while fetching food category", error);
      }
    })();
  }, []);

  const filteredAndSortedCategories = [...foodCategory].sort((a, b) => {
    const aIsPakistani = a.name?.toLowerCase() === "pakistani";
    const bIsPakistani = b.name?.toLowerCase() === "pakistani";

    if (aIsPakistani && !bIsPakistani) return -1;
    if (!aIsPakistani && bIsPakistani) return 1;
    return 0;
  });

  return (
    <>
      <section className="py-12 bg-gradient-to-b from-gray-100 via-gray-50 to-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-20">
            <h2 className="text-5xl font-black tracking-tighter mb-4 text-gray-800">
              Browse By <span className="text-red-600">Cuisine</span>
            </h2>
            <p className="text-xl text-gray-700 font-light max-w-2xl mx-auto">
              Find the flavors that speak to your soul and discover culinary adventures.
            </p>
            <div className="w-24 h-1.5 bg-gradient-to-r from-red-600 to-red-700 rounded-full mx-auto mt-6" />
          </div>
        <div className="relative group">
          {/* Left Arrow */}
{/* Left Arrow */}
<button
  className="browse-prev hidden lg:flex absolute -left-6 top-1/2 -translate-y-1/2 z-40
  w-12 h-12 items-center justify-center
  bg-gradient-to-br from-red-600 to-red-700 
  text-white shadow-lg rounded-lg
  opacity-90 hover:opacity-100 hover:shadow-2xl
  transition-all duration-300 hover:-translate-x-1"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-5 h-5"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth="3"
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
  </svg>
</button>

{/* Right Arrow */}
<button
  className="browse-next hidden lg:flex absolute -right-6 top-1/2 -translate-y-1/2 z-40
  w-12 h-12 items-center justify-center
  bg-gradient-to-br from-red-600 to-red-700 
  text-white shadow-lg rounded-lg
  opacity-90 hover:opacity-100 hover:shadow-2xl
  transition-all duration-300 hover:translate-x-1"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-5 h-5"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth="3"
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
  </svg>
</button>

          <Swiper
  breakpoints={{
    0: { slidesPerView: 1, spaceBetween: 20 },
    640: { slidesPerView: 2, spaceBetween: 20 },
    1024: { slidesPerView: 3, spaceBetween: 30 },
    1280: { slidesPerView: 4, spaceBetween: 30 },
  }}
  navigation={{
    prevEl: ".browse-prev",
    nextEl: ".browse-next",
  }}
  pagination={{ clickable: true }}
  mousewheel
  modules={[Pagination, Navigation]}
  className="browseCategories"
>

            {filteredAndSortedCategories.map((category, index) => (
              <SwiperSlide key={index}>
                <div className="group relative h-96 rounded-3xl shadow-xl overflow-hidden cursor-pointer transform hover:-translate-y-4 transition-all duration-500 bg-white">
                  {/* Enhanced Card Decorations */}
                  <div className="absolute top-4 right-4 w-6 h-6 bg-red-500/30 rounded-full z-20 animate-pulse"></div>
                  <div className="absolute top-8 right-8 w-3 h-3 bg-red-600/40 rounded-full z-20 animate-pulse delay-500"></div>
                  <div className="absolute bottom-4 left-4 w-4 h-4 bg-red-400/50 rounded-full z-20 animate-pulse delay-1000"></div>
                  <div className="absolute inset-0 bg-gradient-to-br from-red-500/5 to-transparent z-10"></div>

                  <div className="absolute inset-2 rounded-2xl overflow-hidden">
                    <img
                      src={
                        category.image && isValidURL(category.image)
                          ? category.image
                          : "https://t4.ftcdn.net/jpg/04/73/25/49/360_F_473254957_bxG9yf4ly7OBO5I0O5KABlN930GwaMQz.jpg"
                      }
                      alt={category.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 ease-out"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent"></div>
                  </div>
                  <Link 
                    to={`/categorize-dishes/${category.id}`} 
                    className="relative h-full flex flex-col justify-end p-8 z-30"
                  >
                    <h3 className="text-3xl font-bold text-white tracking-tight mb-2">{category.name}</h3>
                    <div className="h-1 w-12 bg-red-500 mb-4 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left rounded-full"></div>
                    <p className="text-red-300 opacity-0 group-hover:opacity-100 transition-all duration-500 transform translate-y-2 group-hover:translate-y-0 font-semibold">
                      Explore Dishes 
                      <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        className="inline w-5 h-5 ml-1" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        stroke="currentColor" 
                        strokeWidth="2" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                      >
                        <path d="M5 12h14M12 5l7 7-7 7"/>
                      </svg>
                    </p>
                  </Link>
                </div>
              </SwiperSlide>
            ))}
            <Link
        to="all-dish-detail"
        className="relative h-full w-full flex flex-col justify-center items-center z-30 px-6 text-center"
      >
        <div className="flex flex-col items-center space-y-4">
          <div className="bg-gradient-to-tr from-red-600 to-red-700 rounded-full p-4 shadow-lg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-10 h-10 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </div>
          <h3 className="text-2xl font-bold text-gray-800 group-hover:text-red-600 transition duration-300">
            See All Dishes
          </h3>
          <p className="text-gray-500 font-medium opacity-0 group-hover:opacity-100 group-hover:translate-y-0 transform translate-y-2 transition-all duration-500">
            Explore everything we offer
          </p>
        </div>
      </Link>
          </Swiper>
          </div>
        </div>
      </section>
    </>
  );
};

export default BrowsByCategories;